import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const HowItWorksSection = () => {
  return (
    <section id='funciona' className='py-5 bg-light'>
          <Container>
            <Row className='justify-content-center mb-5'>
              <Col lg={8} className='text-center'>
                <Badge bg='primary' className='mb-3 fw-normal fs-6'>
                  PROCESO DE ENVÍO
                </Badge>
                <h2 className='display-5 fw-bold mb-3'>
                  Así funciona{" "}
                  <span className='text-primary'>MBOX Express</span>
                </h2>
                <p className='lead text-muted'>
                  Un proceso simple y transparente desde Miami hasta tu hogar
                </p>
              </Col>
            </Row>

            {/* LINEA DE TIEMPO */}
            <Row className='timeline-process'>
              <Col xs={12}>
                <div className='timeline-steps'>
                  {/* PASO 1 */}
                  <div className='timeline-step'>
                    <div className='timeline-step-circle'>
                      <div className='timeline-step-circle-inner'>
                        <FaUserPlus size={20} className='text-white' />
                      </div>
                    </div>
                    <div className='timeline-step-content'>
                      <h4 className='mb-2'>Registro</h4>
                      <p className='text-muted mb-0'>
                        Crea tu cuenta gratuita y recibe tu dirección exclusiva
                        en Miami
                      </p>
                    </div>
                  </div>

                  {/* CONECTOR */}
                  <div className='timeline-connector'>
                    <div className='timeline-connector-line'></div>
                    <div className='timeline-connector-arrow'></div>
                  </div>

                  {/* PASO 2 */}
                  <div className='timeline-step'>
                    <div className='timeline-step-circle'>
                      <div className='timeline-step-circle-inner'>
                        <FaShoppingCart size={18} className='text-white' />
                      </div>
                    </div>
                    <div className='timeline-step-content'>
                      <h4 className='mb-2'>Compra</h4>
                      <p className='text-muted mb-0'>
                        Usa tu dirección MBOX como destino de envío en tus
                        compras
                      </p>
                    </div>
                  </div>

                  {/* CONECTOR */}
                  <div className='timeline-connector'>
                    <div className='timeline-connector-line'></div>
                    <div className='timeline-connector-arrow'></div>
                  </div>

                  {/* PASO 3 */}
                  <div className='timeline-step'>
                    <div className='timeline-step-circle'>
                      <div className='timeline-step-circle-inner'>
                        <FaWarehouse size={20} className='text-white' />
                      </div>
                    </div>
                    <div className='timeline-step-content'>
                      <h4 className='mb-2'>Recepción</h4>
                      <p className='text-muted mb-0'>
                        Recibimos tus paquetes en Miami y te notificamos
                      </p>
                    </div>
                  </div>

                  {/* CONECTOR */}
                  <div className='timeline-connector'>
                    <div className='timeline-connector-line'></div>
                    <div className='timeline-connector-arrow'></div>
                  </div>

                  {/* PASO 4 */}
                  <div className='timeline-step'>
                    <div className='timeline-step-circle'>
                      <div className='timeline-step-circle-inner'>
                        <FaHome size={22} className='text-white' />
                      </div>
                    </div>
                    <div className='timeline-step-content'>
                      <h4 className='mb-2'>Entrega</h4>
                      <p className='text-muted mb-0'>
                        Enviamos a Honduras y entregamos en la puerta de tu casa
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className='mt-5 justify-content-center'>
              <Col md={12} lg={11}>
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  viewport={{ once: true }}
                >
                  <Card className='border-0 shadow-sm rounded-4 p-4 bg-white'>
                    <div className='text-center mb-4'>
                      <h2 className='fw-bold text-danger'>
                        <FaPlayCircle className='me-2' />
                        Video Tutoriales MBOX
                      </h2>
                    </div>

                    <div className='row justify-content-center g-4'>
                      {[video1, video2, video3,video4].map((video, idx) => (
                        <div
                          key={idx}
                          className='col-12 col-md-6 col-lg-4 d-flex justify-content-center'
                        >
                          <div
                            className='position-relative'
                            style={{ width: "280px", height: "580px" }}
                          >
                            <div
                              className='position-absolute top-0 start-0 w-100 h-100 rounded-5 overflow-hidden'
                              style={{
                                border: "6px solid #6c757d",
                                boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                                background:
                                  "linear-gradient(145deg, #bdc3c7, #ecf0f1)",
                              }}
                            >
                              {/* Dynamic Island */}
                              <motion.div
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.4, ease: "easeOut" }}
                                className='position-absolute top-0 start-50 translate-middle-x d-flex justify-content-center align-items-center'
                                style={{
                                  width: "100px",
                                  height: "32px",
                                  backgroundColor: "#1a1a1a",
                                  borderRadius: "20px",
                                  marginTop: "8px",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                  zIndex: 10,
                                }}
                              >
                                <div
                                  className='bg-dark rounded-pill mx-2'
                                  style={{ width: "40px", height: "6px" }}
                                ></div>
                                <div
                                  className='bg-secondary rounded-circle ms-2'
                                  style={{ width: "8px", height: "8px" }}
                                ></div>
                              </motion.div>

                              {/* Pantalla con etiqueta VIDEO en lugar de iframe */}
                              <div className='position-absolute top-0 start-0 w-100 h-100 p-2'>
                                <div className='ratio ratio-9x16 h-100 bg-black rounded-4 overflow-hidden'>
                                  <video
                                    src={video}
                                    controls
                                    preload='metadata'
                                    className='w-100 h-100'
                                    style={{ objectFit: "cover" }}
                                  >
                                    Tu navegador no soporta la reproducción de
                                    video.
                                  </video>
                                </div>
                              </div>

                              {/* Barra inferior (gesture bar) */}
                              <div
                                className='position-absolute bottom-0 start-50 translate-middle-x bg-secondary rounded-pill'
                                style={{
                                  width: "25%",
                                  height: "4px",
                                  marginBottom: "10px",
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Card>
                </motion.div>
              </Col>
            </Row>

            {/* BOTON CTA */}
            <Row className='mt-5'>
              <Col className='text-center'>
                <Button
                  variant='primary'
                  size='lg'
                  className='fw-bold px-4 shadow-sm'
                  target='_blank'
                  rel='noreferrer'
                  href='https://mbox-hn.com/crear-casillero'
                  style={{
                    borderRadius: "8px",
                    transition: "transform 0.3s ease",
                    padding: "12px 28px",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-3px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <FaShippingFast className='me-2' /> Comenzar ahora
                </Button>
              </Col>
            </Row>
          </Container>
        </section>
  );
};

export default HowItWorksSection;
